import { WorkOrder } from "@myapp/contract";
import { formatDateDDMMYYYY } from "../../shared/helpers/date";
import { AppointmentStatus } from "@myapp/contract";

export const PLANNED_STATUSES = new Set<AppointmentStatus>([
  "PLANNED",
]);

export function formatDateTime(isoDate: string): string {
  const d = new Date(isoDate);
  const date = formatDateDDMMYYYY(d);
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${date}, ${hours}:${minutes} Uhr`;
}

export function buildObjektString(ext: WorkOrder["external"] | undefined): string {
  return [ext?.gebaeude, ext?.hauseingang, ext?.veAdresse]
    .filter(Boolean)
    .join(", ") || "—";
}

export function getSchadensbeschreibung(ext: WorkOrder["external"] | undefined): string {
  return ext?.individuellerText || ext?.leistungText || "—";
}

export function buildTitle(ext: WorkOrder["external"] | undefined, workOrderId: string): string {
  return ext?.auftragJahr && ext?.auftragNr
    ? `R-${ext.auftragJahr}-${ext.auftragNr}`
    : workOrderId;
}
